export default "__VITE_ASSET__DPQIAdMb__"